import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f8f9fa'
    }}>
      <Result
        status="403"
        title="403"
        subTitle="Non hai i permessi necessari per accedere a questa pagina."
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            Torna alla Dashboard
          </Button>
        }
      />
    </div>
  );
};

export default Unauthorized;